var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityTypeSelect } from '../select/entity-type-select';
var cls = classNames('form-field-entity-select');
export var FormFieldEntitySelectDefaultProps = {
  pageSize: 10
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n\n    .shp--entity-select__dropdown-indicator {\n      margin-top: 0px;\n    }\n    \n    .shp--entity-select__clear-indicator {\n      margin-top: -2px;\n    }\n\n    .shp--entity-select__menu {\n      z-index: 1000;\n    }\n\n  "], ["\n    font-family: ", ";\n\n    .shp--entity-select__dropdown-indicator {\n      margin-top: 0px;\n    }\n    \n    .shp--entity-select__clear-indicator {\n      margin-top: -2px;\n    }\n\n    .shp--entity-select__menu {\n      z-index: 1000;\n    }\n\n  "])), theme.FONT('app'))
});
// -------- Components -------->
var My = {
  NAME: 'FormFieldEntitySelect',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: styled(EntityTypeSelect)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
export var FormFieldEntitySelect = function (props) {
  var componentProps = useComponentProps(My.NAME, FormFieldEntitySelectDefaultProps, props);
  var className = props.className,
    onChange = props.onChange,
    entityTypeName = props.entityTypeName,
    entityTypeDefinition = props.entityTypeDefinition,
    target = props.target,
    type = props.type;
  // ginni.log("FORM FIELD ENTITY SELECT", props);
  // ginni.log("ENTITY TYPE DEFINITION", entityTypeDefinition);
  var selectedItem = props.value;
  var selectBodyProps = target === 'grid' ? {
    colors: {
      border: 'transparent',
      focusWithin: {
        border: 'transparent'
      }
    },
    showFocus: false,
    style: {
      boxShadow: 'none'
    }
  } : {};
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Select, {
    optionMenuInputProps: {
      usePortal: true,
      useMenuTransitions: false,
      bodyProps: selectBodyProps,
      font: 'app',
      selectionsProps: {
        style: {
          flexDirection: 'column'
        }
      }
    },
    label: (entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.label) || entityTypeName,
    entityTypeName: entityTypeName,
    selectedItem: selectedItem,
    onSelect: function (_a) {
      var item = _a.item;
      if (onChange) {
        onChange({
          value: item,
          mutationValue: item === null || item === void 0 ? void 0 : item.id
        });
      }
    }
  }));
};
FormFieldEntitySelect.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;